import { NavigateFunction } from 'react-router-dom';
import { ProjectsValidationError } from '../../services/project/errorHandler';
import {
    FormNotFoundError,
    FormValidationError,
    InvalidFormLinkError,
    RestrictedFormAccessError,
    SimpleFormArchivedError,
} from '../../services/simpleForm/errorHandler';

const ERROR_ROUTES: ReadonlyArray<
    readonly [new (message?: string) => Error, string]
> = [
    [SimpleFormArchivedError, '/error/form-archived'],
    [RestrictedFormAccessError, '/error/restricted-form'],
    [FormNotFoundError, '/error/form-not-found'],
    [InvalidFormLinkError, '/error/form-not-found'],
    [FormValidationError, '/error/invalid-url'],
    [ProjectsValidationError, '/error/invalid-url'],
];

export function handleSimpleFormApiError<T>(
    error: unknown,
    navigate: NavigateFunction,
): Promise<T> {
    for (const [ErrorClass, route] of ERROR_ROUTES) {
        if (error instanceof ErrorClass) {
            navigate(route, { replace: true });
            return new Promise<T>(() => {});
        }
    }
    throw error;
}

export async function withSimpleFormApiErrorHandling<T>(
    operation: () => Promise<T>,
    navigate: NavigateFunction,
): Promise<T> {
    try {
        return await operation();
    } catch (error) {
        return handleSimpleFormApiError<T>(error, navigate);
    }
}
